import React from 'react';
import { NextRaceEventDetailLoadLazy } from '@om-fe/core/core/widgets/omfe-widgets';
import { NextRaceBreadcrumbs } from './next-race-breadcrumbs';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { PlatformTypes } from '@om-fe/utils';
import { useParams } from 'react-router';

interface NextRaceEventRouteParams {
  readonly sportId: string;
}

interface NextRaceEventStoreProps {
  readonly deviceType: PlatformTypes;
}

type NextRaceEventProps = NextRaceEventStoreProps;

const NextRaceEvent = ({
  deviceType,
}: NextRaceEventProps) => {
   const { sportId } = useParams<NextRaceEventRouteParams>();

  return (
    <>
      <NextRaceBreadcrumbs isLarge={deviceType === 'desktop' ? true : false} deviceType={deviceType} sportId={sportId} />
      <NextRaceEventDetailLoadLazy deviceType={deviceType} sportId={sportId}/>
    </>
  );
}

export const NextRaceEventPage = compose(
  connect((state: AppState): NextRaceEventStoreProps  => {

    return {
      deviceType: state.deviceInfo?.platform.type,
    }
  }),
)(NextRaceEvent);